import script from "./EventCalendarPage.vue?vue&type=script&lang=js"
export * from "./EventCalendarPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__